import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import logo from './assets/logo.png';

const LandingPage = () => {
  useEffect(() => {
    document.title = 'LapLeaders - NASCAR DFS & Betting Predictions';
  }, []);
  /* EARLY ACCESS - Commented out for now
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Connect to backend API for email capture
    console.log('Email submitted:', email);
    setSubmitted(true);
    setEmail('');
  };
  */

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <header className="hero">
        <div className="hero-content">
          <div className="logo">
            <img src={logo} alt="LapLeaders" className="hero-logo" />
          </div>
          <h2 className="headline">
            Win More in NASCAR DFS & Betting
          </h2>
          <p className="subheadline">
            Data-driven simulations powered by loop data, practice times, and track-specific analytics
          </p>

          <div className="hero-ctas">
            <Link to="/projections" className="cta-button primary">
              View Projections
            </Link>
            <Link to="/dfs" className="cta-button secondary">
              DFS Optimizer
            </Link>
          </div>

          {/* EARLY ACCESS FORM - Commented out for now
          {!submitted ? (
            <form className="email-capture" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Enter your email for early access"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit">Get Early Access</button>
            </form>
          ) : (
            <div className="success-message">
              ✅ Thanks! We'll notify you when we launch.
            </div>
          )}

          <p className="launch-date">Launching February 2026 • Daytona 500</p>
          */}
        </div>
      </header>

      {/* Features Section */}
      <section className="features">
        <h2 className="section-title">How LapLeaders Works</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Advanced Analytics</h3>
            <p>Loop data tracking driver position every lap, practice speeds, qualifying performance, and historical track trends</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🎲</div>
            <h3>10,000 Simulations</h3>
            <p>10,000 race simulations generate win probability, top 5/10 odds, and finishing position distributions for every driver</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>DFS & Betting Tools</h3>
            <p>Optimized DraftKings lineups and over/under position predictions to find value in betting markets</p>
          </div>
        </div>
      </section>

      {/* Product Features */}
      <section className="product-features">
        <h2 className="section-title">What You Get</h2>
        
        <div className="feature-showcase">
          <div className="feature-detail">
            <h3>🏆 DFS Lineup Optimizer</h3>
            <ul>
              <li>Projected DraftKings points for every driver</li>
              <li>Value score (points per $1,000 salary)</li>
              <li>Auto-generated optimal 6-driver lineups</li>
              <li>GPP tournament strategy recommendations</li>
            </ul>
          </div>

          <div className="feature-detail">
            <h3>📈 Win & Finish Probabilities</h3>
            <ul>
              <li>Win probability for each driver</li>
              <li>Top 5 and Top 10 finish odds</li>
              <li>Sortable by any metric</li>
              <li>Compare to Vegas odds to find value</li>
            </ul>
          </div>

          <div className="feature-detail highlight">
            <h3>🎯 Over/Under Position Tool</h3>
            <p className="feature-description">
              Our exclusive feature: Select any finishing position for any driver and get the exact probability they finish over or under that position.
            </p>
            <div className="example-box">
              <p><strong>Example:</strong></p>
              <p>Chase Elliott - Position 15</p>
              <p className="over">✅ Over 15th: 82.3%</p>
              <p className="under">❌ Under 15th: 17.7%</p>
            </div>
          </div>
        </div>
      </section>

      {/* SAMPLE PREDICTIONS - Commented out (stale data)
      <section className="sample-predictions">
        <h2 className="section-title">Sample Predictions: 2025 Bowman Gray</h2>
        <div className="predictions-table-container">
          <table className="predictions-table">
            <thead>
              <tr>
                <th>Pos</th>
                <th>Driver</th>
                <th>Car</th>
                <th>Win %</th>
                <th>Top 5 %</th>
                <th>Top 10 %</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Joey Logano</td>
                <td>#22</td>
                <td className="win-prob">25.1%</td>
                <td>77.8%</td>
                <td>86.5%</td>
                <td className="value-high">★★★</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Chase Elliott</td>
                <td>#9</td>
                <td className="win-prob">38.0%</td>
                <td>76.3%</td>
                <td>79.6%</td>
                <td className="value-high">★★★</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Tyler Reddick</td>
                <td>#45</td>
                <td className="win-prob">5.1%</td>
                <td>47.4%</td>
                <td>78.1%</td>
                <td className="value-medium">★★</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Christopher Bell</td>
                <td>#20</td>
                <td>4.3%</td>
                <td>42.7%</td>
                <td>76.8%</td>
                <td className="value-medium">★★</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Ryan Blaney</td>
                <td>#12</td>
                <td className="win-prob">14.6%</td>
                <td>64.1%</td>
                <td>77.9%</td>
                <td className="value-high">★★★</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="table-note">
          * Actual predictions based on 10,000 Monte Carlo simulations
        </p>
      </section>
      */}

      {/* PRICING SECTION - Commented out for now
      <section className="pricing">
        <h2 className="section-title">Simple Pricing</h2>
        <div className="pricing-grid">
          <div className="pricing-card">
            <h3>Weekly Pass</h3>
            <div className="price">
              <span className="amount">$9.99</span>
              <span className="period">per race weekend</span>
            </div>
            <ul className="pricing-features">
              <li>✓ Full predictions for 1 race</li>
              <li>✓ DFS lineup optimizer</li>
              <li>✓ Over/Under position tool</li>
              <li>✓ Updated with live practice data</li>
            </ul>
            <button className="cta-button secondary">Choose Weekly</button>
          </div>

          <div className="pricing-card featured">
            <div className="badge">Most Popular</div>
            <h3>Monthly</h3>
            <div className="price">
              <span className="amount">$29.99</span>
              <span className="period">per month</span>
            </div>
            <ul className="pricing-features">
              <li>✓ All races that month (~4-5 races)</li>
              <li>✓ DFS lineup optimizer</li>
              <li>✓ Over/Under position tool</li>
              <li>✓ Priority support</li>
            </ul>
            <button className="cta-button primary">Choose Monthly</button>
          </div>

          <div className="pricing-card">
            <div className="badge best-value">Best Value</div>
            <h3>Season Pass</h3>
            <div className="price">
              <span className="amount">$149.99</span>
              <span className="period">full 2026 season</span>
            </div>
            <ul className="pricing-features">
              <li>✓ All 36 Cup Series races</li>
              <li>✓ DFS lineup optimizer</li>
              <li>✓ Over/Under position tool</li>
              <li>✓ Priority support</li>
              <li>✓ Save $210 vs weekly</li>
            </ul>
            <button className="cta-button secondary">Choose Season</button>
          </div>
        </div>
      </section>
      */}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-simple">
          <img src={logo} alt="LapLeaders" className="footer-logo" />
          <div className="footer-links">
            <Link to="/projections">Projections</Link>
            <Link to="/dfs">DFS Optimizer</Link>
          </div>
          <div className="footer-disclaimer">
            <p>© 2026 LapLeaders. Not affiliated with NASCAR, DraftKings, or FanDuel.</p>
            <p>Please gamble responsibly. 21+ only.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;